import { Directive } from '@angular/core';
import { IMPRINT_CONFIG } from '@bmw-ds/components';

@Directive({
  selector: '[disableImprint]',
  providers: [{ provide: IMPRINT_CONFIG, useValue: undefined }],
})
export class DisableImprintDirective {}
